import React from 'react';
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";


const Breadcrumb = (props) => (
  <Route
    {...props}
    path="*"
    render={routeProps => {
      let parts = routeProps.location.pathname.split("/");
      let length = parts.length

      let id = parts[length - 1]
      if (id) {
        if (props.groups[id]) {
          parts.splice(length - 1, 1, props.groups[id].Name)
        }

        if (props.targetGroups.Products && props.targetGroups.Products[id]) {
          parts.splice(length - 1, 1, props.targetGroups.Products[id].DisplayName)
        }
        if (props.targetGroups.Customers && props.targetGroups.Customers[id]) {
          parts.splice(length - 1, 1, props.targetGroups.Customers[id].DisplayName)
        }

        if (props.mustSells[id]) {
          parts.splice(length - 1, 1, props.mustSells[id].Name)
        }
        if (props.campaigns[id]) {
          parts.splice(length - 1, 1, props.campaigns[id].DisplayName)
        }
        if (props.products[id]) {
          parts.splice(length - 1, 1, props.products[id].ProductDisplayName != null ? props.products[id].ProductDisplayName : props.products[id].ProductName)
        }
        if (props.categories[id]) {
          parts.splice(length - 1, 1, props.categories[id].Name)
        }
        if (props.users[id]) {
          parts.splice(length - 1, 1, props.users[id].name)
        }
      }

      const place = parts[parts.length - 1];
      parts = parts.slice(1, parts.length - 1);

      if (length > 2) {
        return (
          <div className={props.styles.breadcrumb}>
            {parts.map(props.crumb)} <div className={props.styles.divider}>/</div> {place}
          </div>
        );
      }
    }}
  />
);


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { targetGroups } = state.TargetGroupReducer
  const { campaigns } = state.CampaignReducer
  const { mustSells } = state.MustSellReducer
  const { groups } = state.GroupReducer
  const { products } = state.ProductReducer
  const { categories } = state.CategoryReducer
  const { users } = state.UserReducer

  return {
    targetGroups,
    campaigns,
    mustSells,
    groups,
    products,
    categories,
    users
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Breadcrumb)
);

// EXPORT COMPONENT

export { hoc as Breadcrumb };
